import { Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { InputOtpModule } from 'primeng/inputotp';

@Component({
  selector: 'app-otp-input',
  imports: [FormsModule, ButtonModule, InputOtpModule, DividerModule],
  templateUrl: './otp-input.component.html',
  styleUrl: './otp-input.component.scss',
})
export class OtpInputComponent {
  loading = input.required<boolean>();
  showError = input.required<boolean>();
  showEnrollMessage = input<boolean>(false);
  cancelLabel = input<string>('Cancel');
  code = model.required<string>();
  onVerifyCode = output<void>();
  onCancel = output<void>();

  verifyCode() {
    this.onVerifyCode.emit();
  }

  cancel() {
    this.onCancel.emit();
  }
}
